import React from "react";
import { Alert, AlertTitle } from "@mui/material";

const Error = ({ message, ...rest }) => {
  return (
    <Alert severity="error" {...rest}>
      <AlertTitle>Error</AlertTitle>
      {message}
    </Alert>
  );
};

export default Error;
